// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"Checkbox__checkbox___Qv5gn","selected":"Checkbox__selected___D2JnB","disabled":"Checkbox__disabled___YKo-Q","required":"Checkbox__required___3AIfY"};